//////LIBRARY//////
import React, { useEffect, useState, Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import _, { cloneDeep, isEmpty, isUndefined, isEqual, map, isNumber, isNull, find, findIndex, filter } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Link, useHistory, useRouteMatch } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { bindActionCreators } from 'redux'
//////COMPONENTS//////
import { uriList } from '../../../routings/settings/RouteList'
import { initKioskCreationDefinitionActionCreators } from '../../../store/actions'
import Button from '../../../components/Ui/Buttons'
import Tooltip from '../../../components/Tooltip/Tooltip'
import TooltipHelp from '../../../components/TooltipHelp/TooltipHelp'
import CalendarInputInline from '../../../components/CalendarInputInline'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import Theme from '../../../theme/theme'
import StringFormatter from '../../../helpers/StringFormatter'
import KioskPdvHelper from '../../../helpers/KioskPdvHelper'
import UseDatePicker from '../../../hooks/UseDatePicker'
import {
	PageTitle,
	PageWrapperLinks,
	PageWrapperGrids,
	InputWrapper,
	InputLogin,
	ErrorInputMsg,
	LabelText,
	SelectInputWrapper,
	SelectInputCustom,
	OptionCustom,
	ControllerFileWrapper,
	LabelFileCustom,
	SpanTitle,
	PageWrapperActions,
	PageWrapperActionPrevPage,
	TextareaStyled,
} from '../../../theme/GlobalCss'
import { LineTableHeader } from '../../../components/KioskPerimeter/KioskPerimeter'
//////ASSETS//////
import Validation from '../../../assets/icones/global/check.svg'
import DeletePictureIcon from '../../../assets/icones/global/close-red.svg'
import OpenEyeIcon from '../../../assets/icones/global/view.svg'
import CloseEyeIcon from '../../../assets/icones/global/eye-close-blue.svg'
import DeleteRackIcon from '../../../assets/icones/global/trash-white.svg'
import AddRack from '../../../assets/icones/global/add.svg'

//////STYLED//////
const KioskCreationDefinitionCustomerWrapper = styled.div`
	position: relative;
`
const PageWrapperGridsCustom = styled(PageWrapperGrids)`
	grid-column-gap: 10px;
	& > div:last-child {
		border-right: none;
		padding-right: 0px;
	}
`
const KioskCreationDefinitionCustomerColumn = styled.div`
	font-size: ${(props) => props.theme.font.fs};
	border-right: 1px solid ${(props) => props.theme.colors.TabNav.border};
	padding-right: 10px;
	height: 100%;
`
const KioskCreationDefinitionCustomerPart = styled.div``

const KioskCreationDefinitionCustomerTitlePart = styled.span`
	line-height: 32px;
	height: 32px;
	color: ${(props) => props.theme.colors.white};
	background-color: ${(props) => props.theme.colors.primary};
	display: block;
	padding-left: 15px;
	font-weight: bold;
	margin-bottom: 10px;
`
const KioskCreationDefinitionCustomerContentPart = styled.div`
	display: grid;
	grid-row-gap: 20px;
	grid-template-columns: auto;
	padding: 0px 10px 10px 10px;
	margin-top: 10px;
`
const KioskCreationDefinitionCustomerStockRequest = styled.div`
	& > div:first-child {
		display: flex;
		align-items: center;
		& > input {
			margin-right: 10px;
		}
	}
`
const KioskCreationDefinitionCustomerStockRequestQuantity = styled.div`
	display: flex;
	margin-top: 15px;
	align-items: center;
	& input {
		width: 56px;
		margin-left: 10px;
	}
`
const LabelTextCustom = styled(LabelText)`
	margin-bottom: 10px;
`
const UploadHandler = styled.div`
	width: 208px;
`
const UploadFileList = styled.div`
	width: 208px;
	& > div {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
`
const SearchResetCustom = styled.div`
	background-image: url('${DeletePictureIcon}');
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	width: 10px;
	height: 10px;
`
const KioskCreationDefinitionCustomerInfo = styled.div`
	padding: 12px;
	background-color: ${(props) => (props.themed === 'white' ? 'transparent' : props.theme.infoPart.background)};
	border: ${(props) => (props.themed === 'white' ? `1px solid ${props.theme.infoPart.borderBlue}` : 'none')};
	& > div:first-child {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	& > div:first-child span {
		font-weight: bold;
		color: ${(props) => props.theme.colors.primary};
	}
	& > div:first-child img {
		cursor: pointer;
	}
`
const KioskCreationDefinitionCustomerAccountPart = styled.div`
	display: grid;
	grid-template-columns: max-content min-content;
	grid-column-gap: 15px;
	grid-row-gap: 5px;
`
const KioskCreationDefinitionCustomerUserPhone = styled.div`
	padding: 10px 10px 30px 10px;
`
const KioskCreationDefinitionCustomerTogglePart = styled.div`
	display: ${(props) => (props.visible ? 'grid' : 'none')};
	grid-template-columns: auto;
	grid-row-gap: 25px;
	margin: 20px 10px;
	& > div {
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;
	}
`
const KioskCreationDefinitionCustomerSMSAvailable = styled.div`
	display: flex;
	align-items: center;
	& > input {
		margin-right: 10px;
	}
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
const KioskCreationDefinitionCustomerRacksInfoPart = styled.ul`
	list-style-type: none;
	padding: 0px;
	& > li {
		font-weight: ${(props) => (props.level === 0 ? 'bold' : 'normal')};
	}
	& > li > div {
		display: grid;
		grid-template-columns: 55% 45%;
	}
	& > li > div > span:first-child {
		margin-left: ${(props) => (props.level > 0 ? `${props.level * 30}px` : `0px`)};
	}
	& > li > div > span:nth-child(2) {
		color: ${(props) => (props.level > 0 ? props.theme.text.colors.primary : props.theme.colors.primary)};
	}
`
const KioskCreationDefinitionCustomerRacksPart = styled.div`
	display: grid;
	grid-template-columns: auto max-content;
	grid-row-gap: 25px;
`
const KioskCreationDefinitionCustomerRacksPartAccessory = styled.div`
	margin: 0px 25px;
	& > div {
		display: grid;
		grid-template-columns: auto auto;
		grid-column-gap: 10px;
		grid-row-gap: 25px;
	}
`
const AddRackButtonWrapper = styled.div`
	margin: auto;
`
const KioskCreationDefinitionCustomerRacksList = styled.div`
	display: grid;
	grid-template-columns: auto;
	grid-row-gap: 2px;
`
const KioskCreationDefinitionCustomerRackItem = styled.div`
	border-radius: 24px;
	background-color: ${(props) => (props.disabled ? props.theme.colors.eraser : props.theme.colors.primary)};
	padding: 13px 21px;
	& > span {
		color: ${(props) => props.theme.colors.white};
	}
	display: grid;
	grid-template-columns: max-content auto max-content;
	grid-column-gap: 15px;
	& > div > img {
		cursor: pointer;
	}
`
const TextareaStyledCustom = styled(TextareaStyled)`
	margin-top: -25px;
`
//////STYLED//////

const KioskCreationDefinitionCustomer = () => {
	const { translations, userKioskPerimeter, kioskCreation, kioskCreationDefinition, kioskCreationDefinitionOptions } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			kioskCreation: state.initKioskCreation,
			kioskCreationDefinition: state.initKioskCreation.definition,
			kioskCreationDefinitionOptions: state.initKioskCreation.definition.availableOptions,
		}),
		shallowEqual
	)

	const actionsInitKioskCreationDefinition = bindActionCreators(initKioskCreationDefinitionActionCreators, useDispatch())

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const history = useHistory()
	const match = useRouteMatch()

	const [isUpdate, setIsUpdate] = useState(false)
	const [isEditable, setIsEditable] = useState(false)
	const [isEditableSecondCycle, setIsEditableSecondCycle] = useState()

	const [stockRequestCheck, setStockRequestCheck] = useState(false)
	// File handling
	const [listPictures, setListPictures] = useState([])
	const [errorsPictureBase64Msg, setErrorspictureBase64Msg] = useState('')
	const [imgfile, setImgfile] = useState() // Will handle image upload attempt by user
	// Account info
	const [showAccountInfo, setShowAccountInfo] = useState(true)

	// Switches
	const [currentPageSwitches, setCurrentPageSwitches] = useState({})

	// Selected profile
	const [selectedProfile, setSelectedProfile] = useState({})

	// Available racks
	const [availableRackList, setAvailableRackList] = useState([])

	// Selected rack
	const [selectedRack, setSelectedRack] = useState({})

	// Added rack list
	const [addedRackList, setAddedRackList] = useState([])

	const [dataLoaded, setDataLoaded] = useState(false)
	// Recap racks object - customer infos => dynamic
	const [recapRack, setRecapRack] = useState({
		foldedList: [],
		notFoldedList: [],
		smallLockerNumbers: 0,
		mediumLockerNumbers: 0,
		largeLockerNumbers: 0,
		extraLargeLockerNumbers: 0,
		accessoriesList: [],
	})

	// Date picker
	// according to hot fix we don t' need to set a 35 days limit date, to prevent any side effect and
	// in case of we need to apply an other delay we prefer change value to add by 0
	const [
		dateInstallShowModal,
		dateInstallOpenDateModalHandler,
		dateInstallRenderModal,
		dateInstallStateDate,
		dateInstallStartDate,
		dateInstallEndDate,
	] = UseDatePicker({
		noInterval: true,
		noTime: true,
		defaultDateStart: moment().add(0, 'days').toDate(),
		priorStartLimit: moment().add(0, 'days').toDate(),
	})

	const [currentDateInstall, setCurrentDateInstallStateDate] = useState(dateInstallStateDate)

	// Default values of the form
	const [stateDefaultValues, setStateDefaultValues] = useState({
		quantity: null,
		kioskLanguage: '2',
		pictures: [],
		kioskDateInstallation: '',
	})

	const { register, handleSubmit, errors, watch, control, setValue, getValues, setError, clearErrors, unregister } = useForm({
		defaultValues: stateDefaultValues,
	})
	// Files handling
	const fileFromBase64 = (data, key) => {
		// Setting image
		var byteString = !isEmpty(data) ? atob(data.split(',')[1]) : ''
		var mimeString = !isEmpty(data) ? data.split(',')[0].split(':')[1].split(';')[0] : ''

		var ab = new ArrayBuffer(byteString.length)

		var ia = new Uint8Array(ab)
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i)
		}
		// write the ArrayBuffer to a blob, and you're done
		var blob = new Blob([ia], { type: mimeString })

		//A Blob() is almost a File() - it's just missing the two properties below which we will add
		blob.lastModifiedDate = new Date()
		blob.name = `uploadedFile_${key}.png`

		return blob
	}

	///////////////////////////////// HANDLER ///////////////////////////////////////

	const handleFileReading = (files, _noReplaceName = false) => {
		_.forEach(files, (file) => {
			let image = new Image()
			let reader = new FileReader()
			reader.readAsDataURL(file)

			reader.onload = function () {
				image.src = reader.result
				setImgfile({ file: file, readerResult: image.src })
			}
			// In case that we need to handle error this way
			// reader.onerror = function (_error) {}
		})
	}

	const handleDeletePicture = (imgfile) => {
		let ar = cloneDeep(listPictures)
		let ar_pictures = cloneDeep(getValues('pictures'))
		_.forEach(listPictures, (file, indexFile) => {
			if (isEqual(file, imgfile)) {
				ar.splice(indexFile, 1)
				ar_pictures.splice(indexFile, 1)
			}
		})
		setListPictures(ar)
		setValue('pictures', ar_pictures)
	}

	// Actions
	const handleRedirect = () => {
		history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)
	}

	const onSubmit = (data, e) => {
		let datas = cloneDeep(data)
		let datasFromStore = cloneDeep(kioskCreationDefinition.data)
		datas.id = isUpdate ? match.params.id : kioskCreation.requestId ? kioskCreation.requestId : null
		datas.requestName =
			(!isUndefined(datasFromStore.requestName) && !isUndefined(datasFromStore.requestName) === datas.requestName) ||
			isUndefined(datas.requestName)
				? datasFromStore.requestName
				: datas.requestName
		datas.kioskDateInstallation = moment(currentDateInstall.date.startDate).toDate()
		let pics = []
		if (isUndefined(datas.pictures)) pics = []
		if (!isEmpty(datas.pictures)) {
			_.forEach(datas.pictures, (pict) => {
				pics.push({ pictureBase64: pict })
			})
		}
		//datas.pictures = pics
		delete datas.pictures

		datas.quantity = isEmpty(datas.quantity) ? null : parseInt(datas.quantity)

		datas.storeInformation = {
			storeLabelCommercial: datas.storeLabelCommercial,
			storeType: parseInt(datas.storeType) > 0 ? parseInt(datas.storeType) : null,
			storeAddress: datas.storeAddress,
			storePostalCode: datas.storePostalCode,
			storeCity: datas.storeCity,
			storeCountry: datas.storeCountry,
			storeSiret: datas.storeSiret,
			storeEmail: datas.storeEmail,
			maintainer: datas.maintainer,
			storePhoneNumber: datas.storePhoneNumber,
			smsAvailable: datas.smsAvailable,
			pictures: pics,
		}

		delete datas.storeLabelCommercial
		delete datas.storeType
		delete datas.storeAddress
		delete datas.storePostalCode
		delete datas.storeCity
		delete datas.storeCountry
		delete datas.storeSiret
		delete datas.storeEmail
		delete datas.maintainer
		delete datas.storePhoneNumber
		delete datas.smsAvailable

		datas.contactInformation = {
			currentUserPhoneNumber: datas.currentUserPhoneNumber,
			contactLastName: datas.contactLastName,
			contactFirstName: datas.contactFirstName,
			contactEmail: datas.contactEmail,
			contactPhoneNumber: datas.contactPhoneNumber,
		}

		delete datas.currentUserPhoneNumber
		delete datas.contactLastName
		delete datas.contactFirstName
		delete datas.contactEmail
		delete datas.contactPhoneNumber

		datas.kioskInformation = {
			//kioskModel: parseInt(datas.kioskModel),
			kioskModel: !isUndefined(
				filter(datasFromStore.kioskModels, (e) => {
					if (e.selected) return e.id
				})[0]?.id
			)
				? filter(datasFromStore.kioskModels, (e) => {
						if (e.selected) return e.id
				  })[0]?.id
				: datas.kioskModel,
			kioskLabelToOwner: datas.kioskLabelToOwner,
			kioskDescription: datas.kioskDescription,
			kioskDateInstallation: datas.kioskDateInstallation,
			kioskLanguage: parseInt(datas.kioskLanguage),
			welcomeMessage: datas.welcomeMessage,
			installationType: parseInt(datas.installationType) > 0 ? parseInt(datas.installationType) : null,
			//kioskOwnerConfig: parseInt(datas.kioskOwnerConfig),
			kioskOwnerConfig: !isUndefined(
				filter(datasFromStore.kioskOwnerConfigs, (e) => {
					if (e.selected) return e.id
				})[0]?.id
			)
				? filter(datasFromStore.kioskOwnerConfigs, (e) => {
						if (e.selected) return e.id
				  })[0]?.id
				: datas.kioskOwnerConfig,
			bottleDetectionAvailable: datas.bottleDetectionAvailable,
			codePaymentAvailable: datas.codePaymentAvailable,
			tpaAvailable: datas.tpaAvailable,
			scaleAvailable: datas.scaleAvailable,
			printerAvailable: datas.printerAvailable,
			ticketByMailAvailable: datas.ticketByMailAvailable,
			solarPanelAvailable: datas.solarPanelAvailable,
			pda: datas.pda,
			solidDoor: datas.solidDoor,
			lateralPanel: datas.lateralPanel,
			interiorCover: datas.interiorCover,
			restrictedLocation: datas.restrictedLocation,
			bottleMatterSensor: datas.bottleMatterSensor,
			platineSet: datas.platineSet,
			marker: datas.marker,
			barCodeReader: datas.barCodeReader,
		}

		delete datas.kioskModel
		delete datas.kioskLabelToOwner
		delete datas.kioskDescription
		delete datas.kioskDateInstallation
		delete datas.kioskLanguage
		delete datas.welcomeMessage
		delete datas.installationType
		delete datas.kioskOwnerConfig
		delete datas.bottleDetectionAvailable
		delete datas.codePaymentAvailable
		delete datas.tpaAvailable
		delete datas.scaleAvailable
		delete datas.printerAvailable
		delete datas.ticketByMailAvailable
		delete datas.solarPanelAvailable
		delete datas.pda
		delete datas.solidDoor
		delete datas.lateralPanel
		delete datas.interiorCover
		delete datas.restrictedLocation
		delete datas.bottleMatterSensor
		delete datas.platineSet
		delete datas.marker
		delete datas.barCodeReader

		if (!selectedProfile.standardProfile) {
			datas.kioskInformation.noteCommercial = datas.noteCommercial
			delete datas.noteCommercial
		} else {
			datas.displayStandsInformation = map(addedRackList, (o) => {
				return {
					idDisplayStandModel: parseInt(o.idDisplayStandModel),
					displayStandName: o.displayStandName,
					displayStandFolded: o.displayStandFolded,
					idAccessoryLockersNumber: parseInt(o.idAccessoryLockersNumber) > 0 ? parseInt(o.idAccessoryLockersNumber) : null,
					idAccessoryDisplayStandModel: parseInt(o.idAccessoryDisplayStandModel) > 0 ? parseInt(o.idAccessoryDisplayStandModel) : null,
					isMain: o.isMain,
					allowAccessoryRack: o.allowAccessoryRack,
					allowMultiMain: o.allowMultiMain,
				}
			})
		}

		delete datas.idDisplayStandModel

		switch (e?.nativeEvent?.submitter?.id) {
			/*case "ActionSave":
				actionsInitKioskCreationDefinition.saveDefinitionCustomer(datas)
				break;*/
			case 'ActionCreate':
				actionsInitKioskCreationDefinition.createDefinitionCustomer(datas)
				break
			default:
				break
		}
	}
	const handleStockRequestCheck = () => {
		// To prevent check on required fields that are not displayed
		if (!stockRequestCheck) unregister(['installationType', 'kioskDateInstallation', 'storeCountry', 'storeType', 'kioskLanguage'])
		setStockRequestCheck(!stockRequestCheck)
	}

	// When changing switch
	const handleSwitchChange = (switchElem) => {
		let pageSwitches = cloneDeep(currentPageSwitches)
		switch (switchElem) {
			case 'interiorCover':
				setValue('interiorCover', !pageSwitches.interiorCover)
				pageSwitches.interiorCover = !pageSwitches.interiorCover
				break
			case 'lateralPanel':
				setValue('lateralPanel', !pageSwitches.lateralPanel)
				pageSwitches.lateralPanel = !pageSwitches.lateralPanel
				break
			case 'pda':
				setValue('pda', !pageSwitches.pda)
				pageSwitches.pda = !pageSwitches.pda
				break
			case 'restrictedLocation':
				setValue('restrictedLocation', !pageSwitches.restrictedLocation)
				pageSwitches.restrictedLocation = !pageSwitches.restrictedLocation
				break
			case 'solidDoor':
				setValue('solidDoor', !pageSwitches.solidDoor)
				pageSwitches.solidDoor = !pageSwitches.solidDoor
				break
			default:
				break
		}
		setCurrentPageSwitches(pageSwitches)
	}

	// When selecting model
	const handleChangeKioskModel = (idKioskModel) => {
		actionsInitKioskCreationDefinition.getProfilesByKioskCustomer(idKioskModel)
	}

	// When selecting profile
	const handleChangeProfile = (idProfile) => {
		setAddedRackList([])
		setRecapRack({
			foldedList: [],
			notFoldedList: [],
			smallLockerNumbers: 0,
			mediumLockerNumbers: 0,
			largeLockerNumbers: 0,
			extraLargeLockerNumbers: 0,
			accessoriesList: [],
		})
		actionsInitKioskCreationDefinition.getProfileConfigCustomer(idProfile)
	}

	// When changing profile config switch
	const handleProfileSelectedChange = (switchElem) => {
		let profile = cloneDeep(selectedProfile)
		switch (switchElem) {
			case 'bottleDetectionAvailable':
				setValue('bottleDetectionAvailable', !profile.bottleDetectionAvailable)
				profile.bottleDetectionAvailable = !profile.bottleDetectionAvailable
				break
			case 'codePaymentAvailable':
				setValue('codePaymentAvailable', !profile.codePaymentAvailable)
				profile.codePaymentAvailable = !profile.codePaymentAvailable
				break
			case 'tpaAvailable':
				setValue('tpaAvailable', !profile.tpaAvailable)
				profile.tpaAvailable = !profile.tpaAvailable
				break
			case 'scaleAvailable':
				setValue('scaleAvailable', !profile.scaleAvailable)
				profile.scaleAvailable = !profile.scaleAvailable
				break
			case 'printerAvailable':
				setValue('printerAvailable', !profile.printerAvailable)
				profile.printerAvailable = !profile.printerAvailable
				break
			case 'ticketByMailAvailable':
				setValue('ticketByMailAvailable', !profile.ticketByMailAvailable)
				profile.ticketByMailAvailable = !profile.ticketByMailAvailable
				break
			case 'solarPanelAvailable':
				setValue('solarPanelAvailable', !profile.solarPanelAvailable)
				profile.solarPanelAvailable = !profile.solarPanelAvailable
				break
			case 'platineSet':
				setValue('platineSet', !profile.platineSet)
				profile.platineSet = !profile.platineSet
				break
			case 'marker':
				setValue('marker', !profile.marker)
				profile.marker = !profile.marker
				break
			case 'bottleMatterSensor':
				setValue('bottleMatterSensor', !profile.bottleMatterSensor)
				profile.bottleMatterSensor = !profile.bottleMatterSensor
				break
			case 'barCodeReader':
				setValue('barCodeReader', !profile.barCodeReader)
				profile.barCodeReader = !profile.barCodeReader
				break
			default:
				break
		}
		setSelectedProfile(profile)
	}

	const handleChangeRack = (idRack) => {
		let rack = find(availableRackList, { id: parseInt(idRack) })
		if (isUndefined(rack.displayStandFolded)) rack.displayStandFolded = false
		// If accessory fields exists, it means that we CAN add accessory, but it is not mandatory
		// In this case, we set it on false by default
		if (!isUndefined(rack.accessoryRack)) rack.accessoryRack = false
		setSelectedRack(rack)
	}

	// When changing rack model switch
	const handleRackModelSelectedChange = (switchElem) => {
		let rack = cloneDeep(selectedRack)

		switch (switchElem) {
			case 'displayStandFolded':
				rack.displayStandFolded = !rack.displayStandFolded
				break
			/*case "solar":
				rack.solar = !rack.solar
				break;*/
			case 'accessoryRack':
				rack.accessoryRack = !rack.accessoryRack
				break
			default:
				break
		}
		setSelectedRack(rack)
	}

	// When adding or removing rack to our list
	const handleRackList = (mode, keyRackDelete, labelDelete, labelAccessory) => {
		let listRacks = cloneDeep(addedRackList)
		let recapRackInfos = cloneDeep(recapRack)
		if (mode === 'add') {
			const nextIncrement = listRacks.length + 1
			const accessory = find(selectedRack.accessoryDisplayStandModels, (o) => o.id === parseInt(getValues('idAccessoryLockersNumber')))

			const rackToAdd = {
				idDisplayStandModel: selectedRack.id,
				displayStandName: `Rack WDCodeBorneWD-${nextIncrement}`,
				labelRack: selectedRack.label,
				labelAccessory: !isUndefined(accessory) ? translations[accessory.translationKey] : '',
				displayStandFolded: selectedRack.displayStandFolded,
				idAccessoryLockersNumber: getValues('idAccessoryLockersNumber'),
				idAccessoryDisplayStandModel: getValues('idAccessoryDisplayStandModel'),
				isMain: selectedRack.isMain,
				allowAccessoryRack: selectedRack.allowAccessoryRack,
				allowMultiMain: selectedRack.allowMultiMain,
			}

			// Adding lockers number, folded or not
			if (selectedRack.displayStandFolded) {
				const f = findIndex(recapRackInfos.foldedList, (o) => o.label === selectedRack.label)
				const obj = find(recapRackInfos.foldedList, (o) => o.label === selectedRack.label)
				if (f === -1) {
					recapRackInfos.foldedList.push({
						id: selectedRack.id,
						label: selectedRack.label,
						count: 1,
						smallLockerNumbers: selectedRack.foldedSmallLockers,
						mediumLockerNumbers: selectedRack.foldedMediumLockers,
						largeLockerNumbers: selectedRack.foldedLargeLockers,
						extraLargeLockerNumbers: selectedRack.foldedExtraLargeLockers,
					})
				} else {
					obj.count++
					recapRackInfos.foldedList[f] = obj
				}

				// Adding locker numbers
				recapRackInfos.smallLockerNumbers += selectedRack.foldedSmallLockers
				recapRackInfos.mediumLockerNumbers += selectedRack.foldedMediumLockers
				recapRackInfos.largeLockerNumbers += selectedRack.foldedLargeLockers
				recapRackInfos.extraLargeLockerNumbers += selectedRack.foldedExtraLargeLockers
			} else {
				const f = findIndex(recapRackInfos.notFoldedList, (o) => o.label === selectedRack.label)
				const obj = find(recapRackInfos.notFoldedList, (o) => o.label === selectedRack.label)
				if (f === -1) {
					recapRackInfos.notFoldedList.push({
						id: selectedRack.id,
						label: selectedRack.label,
						count: 1,
						smallLockerNumbers: selectedRack.smallLockers,
						mediumLockerNumbers: selectedRack.mediumLockers,
						largeLockerNumbers: selectedRack.largeLockers,
						extraLargeLockerNumbers: selectedRack.extraLargeLockers,
					})
				} else {
					obj.count++
					recapRackInfos.notFoldedList[f] = obj
				}
				// Adding locker numbers
				recapRackInfos.smallLockerNumbers += selectedRack.smallLockers
				recapRackInfos.mediumLockerNumbers += selectedRack.mediumLockers
				recapRackInfos.largeLockerNumbers += selectedRack.largeLockers
				recapRackInfos.extraLargeLockerNumbers += selectedRack.extraLargeLockers
			}

			// Adding locker numbers for accessory
			// Check if accessory is existing ?
			const fAccIndex = findIndex(recapRackInfos.accessoriesList, (o) => (o.id = parseInt(rackToAdd.idAccessoryDisplayStandModel)))
			if (!isUndefined(getValues('idAccessoryDisplayStandModel'))) {
				if (fAccIndex === -1) {
					const objAccType = find(
						selectedRack.accessoryDisplayStandModels,
						(o) => o.id === parseInt(rackToAdd.idAccessoryDisplayStandModel)
					)
					const objAccCount = find(selectedRack.accessoryDisplayLockersNumber, (o) => o.id === parseInt(rackToAdd.idAccessoryLockersNumber))
					recapRackInfos.accessoriesList.push({
						id: parseInt(rackToAdd.idAccessoryDisplayStandModel),
						count: 1,
						countRacks: parseInt(objAccCount.label),
						label: objAccType.label,
					})
					recapRackInfos.smallLockerNumbers += parseInt(objAccCount.label)
				} else {
					recapRackInfos.accessoriesList[fAccIndex].count++
					recapRackInfos.smallLockerNumbers += parseInt(recapRackInfos.accessoriesList[fAccIndex].countRacks)
					//recapRackInfos.accessoriesList[fAccIndex].countRacks += parseInt(objAccCount.label)
				}
			}

			listRacks.push(rackToAdd)
		}
		if (mode === 'delete') {
			// See if our rack is folded ?
			let addedRack
			if (labelAccessory) {
				addedRack = find(
					addedRackList,
					(o) =>
						(o.labelRack === labelDelete && o.labelAccessory === labelAccessory) ||
						(translations[o.idDisplayStandModelName] === labelDelete && o.labelAccessory === labelAccessory)
				)
			} else {
				addedRack = find(addedRackList, (o) => o.labelRack === labelDelete || translations[o.idDisplayStandModelName] === labelDelete)
			}

			if (addedRack.displayStandFolded) {
				const f = findIndex(recapRackInfos.foldedList, (o) => o.label === labelDelete)
				const obj = find(recapRackInfos.foldedList, (o) => o.label === labelDelete)
				if (f > -1) {
					obj.count--

					// Removing locker numbers
					recapRackInfos.smallLockerNumbers -= obj.smallLockerNumbers
					recapRackInfos.mediumLockerNumbers -= obj.mediumLockerNumbers
					recapRackInfos.largeLockerNumbers -= obj.largeLockerNumbers
					recapRackInfos.extraLargeLockerNumbers -= obj.extraLargeLockerNumbers

					if (obj.count === 0) recapRackInfos.foldedList = _.remove(recapRackInfos.foldedList, (o) => o.label !== labelDelete)
					else recapRackInfos.foldedList[f] = obj
				}
			} else {
				const f = findIndex(recapRackInfos.notFoldedList, (o) => o.label === labelDelete)
				const obj = find(recapRackInfos.notFoldedList, (o) => o.label === labelDelete)
				if (f > -1) {
					obj.count--

					// Removing locker numbers
					recapRackInfos.smallLockerNumbers -= obj.smallLockerNumbers
					recapRackInfos.mediumLockerNumbers -= obj.mediumLockerNumbers
					recapRackInfos.largeLockerNumbers -= obj.largeLockerNumbers
					recapRackInfos.extraLargeLockerNumbers -= obj.extraLargeLockerNumbers

					if (obj.count === 0) recapRackInfos.notFoldedList = _.remove(recapRackInfos.notFoldedList, (o) => o.label !== labelDelete)
					else recapRackInfos.notFoldedList[f] = obj
				}
			}

			// Also removing accessories locker from count
			if (!isUndefined(addedRack.idAccessoryDisplayStandModel) || labelAccessory.length > 0) {
				const fAcc = find(recapRackInfos.accessoriesList, (o) => o.id === parseInt(addedRack.idAccessoryDisplayStandModel))
				const fAccIndex = findIndex(recapRackInfos.accessoriesList, (o) => o.id === parseInt(addedRack.idAccessoryDisplayStandModel))
				if (!isUndefined(fAcc)) {
					fAcc.count--

					recapRackInfos.smallLockerNumbers -= parseInt(fAcc.countRacks)
					if (fAcc.count === 0)
						recapRackInfos.accessoriesList = _.remove(
							recapRackInfos.accessoriesList,
							(o) => o.id !== parseInt(addedRack.idAccessoryDisplayStandModel)
						)
					else recapRackInfos.accessoriesList[fAccIndex] = fAcc
				}
			}

			_.remove(listRacks, (_o, key) => key === parseInt(keyRackDelete))
		}

		// Controlling presences of main racks, multi main racks, etc...
		const mainRackCount = _.countBy(listRacks, (o) => o.isMain)
		const multiMainRackCount = _.countBy(listRacks, (o) => o.allowMultiMain)

		// No main or multi main => complete reset
		if (isUndefined(mainRackCount.true) && isUndefined(multiMainRackCount.true)) {
			recapRackInfos = {
				foldedList: [],
				notFoldedList: [],
				smallLockerNumbers: 0,
				mediumLockerNumbers: 0,
				largeLockerNumbers: 0,
				extraLargeLockerNumbers: 0,
				accessoriesList: [],
			}
			listRacks = []
		}
		// If multimain count is the same of main count, it means that we can't have secondary racks anymore
		else if (
			!isUndefined(mainRackCount.true) &&
			!isUndefined(multiMainRackCount.true) &&
			mainRackCount.true === multiMainRackCount.true &&
			listRacks.length > 1
		) {
			let newListRacks = cloneDeep(listRacks)
			// Automatically removing secondary racks
			listRacks.forEach((elem, _key) => {
				if (!elem.isMain) {
					const idRack = elem.idDisplayStandModel // It is his id, not the index of element !
					const folded = elem.displayStandFolded
					const accStore = find(availableRackList, (o) => o.id === idRack)
					if (folded) {
						recapRackInfos.foldedList = filter(recapRackInfos.foldedList, (o) => {
							return o.id !== idRack
						})
						// And removing lockers numbers...
						recapRackInfos.smallLockerNumbers -= accStore.foldedSmallLockers
						recapRackInfos.mediumLockerNumbers -= accStore.foldedMediumLockers
						recapRackInfos.largeLockerNumbers -= accStore.foldedLargeLockers
						recapRackInfos.extraLargeLockerNumbers -= accStore.foldedExtraLargeLockers
					} else {
						recapRackInfos.notFoldedList = filter(recapRackInfos.notFoldedList, (o) => {
							return o.id !== idRack
						})
						// And removing lockers numbers...
						recapRackInfos.smallLockerNumbers -= accStore.smallLockers
						recapRackInfos.mediumLockerNumbers -= accStore.mediumLockers
						recapRackInfos.largeLockerNumbers -= accStore.largeLockers
						recapRackInfos.extraLargeLockerNumbers -= accStore.extraLargeLockers
					}

					// Handling accessories
					if (!isUndefined(elem.idAccessoryDisplayStandModel)) {
						const fAcc = find(recapRackInfos.accessoriesList, (o) => o.id === parseInt(elem.idAccessoryDisplayStandModel))

						if (!isUndefined(fAcc)) {
							recapRackInfos.accessoriesList = _.remove(
								recapRackInfos.accessoriesList,
								(o) => o.id !== parseInt(elem.idAccessoryDisplayStandModel)
							)
						}
					}

					newListRacks = _.remove(newListRacks, (o) => o.idDisplayStandModel !== idRack)
				}
				//return elem
			})
			listRacks = newListRacks
			// Reincrement rack list on delete
			listRacks.forEach((elem, key) => {
				elem.displayStandName = `Rack WDCodeBorneWD-${key + 1}`
				return elem
			})
		}
		setValue('idDisplayStandModel', 0)
		setSelectedRack({})
		setRecapRack(recapRackInfos)
		setAddedRackList(listRacks)
	}

	///////////////////////////////// USE EFFECT ///////////////////////////////////////

	useEffect(() => {
		if (isEmpty(translations)) return
		//actionsInitKioskCreationDefinition.getAvailableListsCustomer()
		if (!isUndefined(match.params.id)) {
			actionsInitKioskCreationDefinition.getDefinitionCustomer(match.params.id)
			setIsUpdate(true)
		} else {
			actionsInitKioskCreationDefinition.getAvailableListsCustomer()
			setIsEditable(true)
		}

		// Also setting registered switches
		setValue('interiorCover', false)
		setValue('lateralPanel', false)
		setValue('pda', false)
		setValue('restrictedLocation', false)
		setValue('solidDoor', false)

		let pageSwitches = cloneDeep(currentPageSwitches)
		pageSwitches.interiorCover = false
		pageSwitches.lateralPanel = false
		pageSwitches.pda = false
		pageSwitches.restrictedLocation = false
		pageSwitches.solidDoor = false
		setCurrentPageSwitches(pageSwitches)

		return function cleanUp() {
			actionsInitKioskCreationDefinition.resetDataCreationCustomer()
		}
	}, [translations])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		if (!isUndefined(imgfile?.readerResult)) {
			const image = new Image()
			const extension = imgfile?.file.name.split('.').pop().toLowerCase()
			const isSuccess = ['png', 'jpeg', 'jpg'].indexOf(extension)

			image.src = imgfile?.readerResult

			if (isSuccess < 0 || image.naturalHeight === 0 || image.naturalWidth === 0 || imgfile?.file.size > 2000000) {
				setErrorspictureBase64Msg(translations['common__message__item_picture_isNotValid'])
			} else {
				setErrorspictureBase64Msg('')
				if (!isNull(document.getElementById('pictureBase64').files)) {
					let ar = cloneDeep(listPictures)
					let ar_pictures = cloneDeep(getValues('pictures'))
					if (isEmpty(ar_pictures) || isUndefined(ar_pictures)) ar_pictures = []
					_.forEach(document.getElementById('pictureBase64').files, (file) => {
						// Only push if element doesn't exist in our list
						const f = find(ar, (o) => isEqual(o, file)) ? true : false
						if (!f) ar.push(file)

						!isEmpty(ar_pictures) ? ar_pictures.push(image.src) : (ar_pictures = [image.src])
						setValue('pictures', ar_pictures)
					})
					setListPictures(ar)
				}
			}
		}
	}, [imgfile])

	useEffect(() => {
		if (isEqual(listPictures, {})) {
			setListPictures([])
			if (!isNull(document.getElementById('pictureBase64').files)) {
				document.getElementById('pictureBase64').value = ''
			}
			setValue('pictures', [])
		} else if (isEmpty(listPictures)) {
			if (!isNull(document.getElementById('pictureBase64').files)) {
				document.getElementById('pictureBase64').value = ''
			}
			setValue('pictures', [])
		} /*else{
			let ar = []
			let image = new Image()
			_.forEach(listPictures, pict => {
				var reader = new FileReader();
				reader.readAsDataURL(pict);

				reader.onload = function () {

					//const image = new Image()
					image.src = reader.result;

					!isEmpty(ar) ? ar.push(image.src) : ar = [image.src]
					setValue("pictures",ar)
				}
			})
		}*/
	}, [listPictures])

	useEffect(() => {
		if (dateInstallStateDate.showModal) {
			setCurrentDateInstallStateDate(dateInstallStateDate)
		}
	}, [dateInstallShowModal])

	useEffect(() => {
		// If our state hook is not undefined, we can process
		// otherwise the error message will be shown
		if (!isUndefined(currentDateInstall)) {
			setValue('kioskDateInstallation', `${moment(currentDateInstall.date.startDate).format('DD-MM-YYYY')}`)
			clearErrors('kioskDateInstallation')
		} else {
			// If field is not undefined, it means that his value has been set, so error message can be printed
			// We are not in page loading anymore
			if (!isUndefined(getValues('kioskDateInstallation'))) {
				setError('kioskDateInstallation', { type: 'required', message: translations['common__text__requiredField'] })
				setValue('kioskDateInstallation', '')
			}
		}
	}, [currentDateInstall])

	// When selected profile is updated
	useEffect(() => {
		if (!isUndefined(kioskCreationDefinitionOptions.selectedProfile) && !isEqual(kioskCreationDefinitionOptions.selectedProfile, {})) {
			setValue('bottleDetectionAvailable', kioskCreationDefinitionOptions.selectedProfile.bottleDetectionAvailable)
			setValue('codePaymentAvailable', kioskCreationDefinitionOptions.selectedProfile.codePaymentAvailable)
			setValue('tpaAvailable', kioskCreationDefinitionOptions.selectedProfile.tpaAvailable)
			setValue('scaleAvailable', kioskCreationDefinitionOptions.selectedProfile.scaleAvailable)
			setValue('printerAvailable', kioskCreationDefinitionOptions.selectedProfile.printerAvailable)
			setValue('ticketByMailAvailable', kioskCreationDefinitionOptions.selectedProfile.ticketByMailAvailable)
			setValue('solarPanelAvailable', kioskCreationDefinitionOptions.selectedProfile.solarPanelAvailable)
			setValue('platineSet', kioskCreationDefinitionOptions.selectedProfile.platineSet)
			setValue('marker', kioskCreationDefinitionOptions.selectedProfile.marker)
			setValue('bottleMatterSensor', kioskCreationDefinitionOptions.selectedProfile.bottleMatterSensor)
			setValue('barCodeReader', kioskCreationDefinitionOptions.selectedProfile.barCodeReader)

			setAvailableRackList(kioskCreationDefinitionOptions.selectedProfile.displayStandConfig)
			setSelectedProfile(kioskCreationDefinitionOptions.selectedProfile)
		}
	}, [kioskCreationDefinitionOptions])
	useEffect(() => {
		register({ name: 'pictures' } /*,{required: {value:true, message:translations['common__text__requiredField']}}*/)
		register(
			{ name: 'kioskDateInstallation' },
			{
				required: {
					value: true,
					message: translations['common__text__requiredField'],
				},
			}
		)
	}, [register, translations])
	// On data loaded
	useEffect(() => {
		if (!isEqual(kioskCreationDefinition.data, {}) && isUpdate && !isEqual(selectedProfile, {}) && !dataLoaded) {
			setStockRequestCheck(kioskCreationDefinition.data.stockRequest)
			setValue('stockRequest', kioskCreationDefinition.data.stockRequest)
			setValue('quantity', kioskCreationDefinition.data.quantity)
			setValue('requestName', kioskCreationDefinition.data.requestName)

			setValue('storeLabelCommercial', kioskCreationDefinition.data.storeInformation.storeLabelCommercial)
			setValue('storeAddress', kioskCreationDefinition.data.storeInformation.storeAddress)
			setValue('storePostalCode', kioskCreationDefinition.data.storeInformation.storePostalCode)
			setValue('storeCity', kioskCreationDefinition.data.storeInformation.storeCity)
			setValue('storeSiret', kioskCreationDefinition.data.storeInformation.storeSiret)
			setValue('storeEmail', kioskCreationDefinition.data.storeInformation.storeEmail)
			setValue('maintainer', kioskCreationDefinition.data.storeInformation.maintainer)
			!isNull(kioskCreationDefinition.data.storeInformation.storePhoneNumber) &&
				setValue('storePhoneNumber', kioskCreationDefinition.data.storeInformation.storePhoneNumber)
			setValue('pictures', kioskCreationDefinition.data.storeInformation.pictures)
			setValue('smsAvailable', kioskCreationDefinition.data.storeInformation.smsAvailable)

			setValue('contactLastName', kioskCreationDefinition.data.contactInformation.contactLastName)
			setValue('contactFirstName', kioskCreationDefinition.data.contactInformation.contactFirstName)
			setValue('contactEmail', kioskCreationDefinition.data.contactInformation.contactEmail)
			!isNull(kioskCreationDefinition.data.contactInformation.contactPhoneNumber) &&
				setValue('contactPhoneNumber', kioskCreationDefinition.data.contactInformation.contactPhoneNumber)

			setValue('bottleDetectionAvailable', kioskCreationDefinition.data.kioskInformation.bottleDetectionAvailable)
			setValue('codePaymentAvailable', kioskCreationDefinition.data.kioskInformation.codePaymentAvailable)
			setValue('tpaAvailable', kioskCreationDefinition.data.kioskInformation.tpaAvailable)
			setValue('scaleAvailable', kioskCreationDefinition.data.kioskInformation.scaleAvailable)
			setValue('printerAvailable', kioskCreationDefinition.data.kioskInformation.printerAvailable)
			setValue('ticketByMailAvailable', kioskCreationDefinition.data.kioskInformation.ticketByMailAvailable)
			setValue('solarPanelAvailable', kioskCreationDefinition.data.kioskInformation.solarPanelAvailable)
			setValue('platineSet', kioskCreationDefinition.data.kioskInformation.platineSet)
			setValue('marker', kioskCreationDefinition.data.kioskInformation.marker)
			setValue('kioskLabelToOwner', kioskCreationDefinition.data.kioskInformation.kioskLabelToOwner)
			setValue('kioskDescription', kioskCreationDefinition.data.kioskInformation.kioskDescription)
			setValue('welcomeMessage', kioskCreationDefinition.data.kioskInformation.welcomeMessage)
			setValue('bottleMatterSensor', kioskCreationDefinition.data.kioskInformation.bottleMatterSensor)
			setValue('barCodeReader', kioskCreationDefinition.data.kioskInformation.bottleMatterSensor)

			!isNull(kioskCreationDefinition.data.currentUserPhoneNumber) &&
				setValue('currentUserPhoneNumber', kioskCreationDefinition.data.userCreated.phoneNumber)

			if (!isNull(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation)) {
				setValue('kioskDateInstallation', moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).format('DD/MM/YYYY'))
				currentDateInstall.date.startDate = moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).toDate()
				dateInstallStartDate(moment(kioskCreationDefinition.data.kioskInformation.kioskDateInstallation).toDate())
			}

			if (kioskCreationDefinition.data.stockRequest) {
				unregister(['installationType', 'kioskDateInstallation', 'storeCountry', 'storeType', 'kioskLanguage'])
			}

			let pageSwitches = cloneDeep(currentPageSwitches)
			pageSwitches.interiorCover = kioskCreationDefinition.data.kioskInformation.interiorCover
			pageSwitches.lateralPanel = kioskCreationDefinition.data.kioskInformation.lateralPanel
			pageSwitches.pda = kioskCreationDefinition.data.kioskInformation.pda
			pageSwitches.restrictedLocation = kioskCreationDefinition.data.kioskInformation.restrictedLocation
			pageSwitches.solidDoor = kioskCreationDefinition.data.kioskInformation.solidDoor
			setCurrentPageSwitches(pageSwitches)

			let valueSelect
			valueSelect = find(kioskCreationDefinition.data.storeTypes, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('storeType', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.countries, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('storeCountry', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.kioskModels, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskModel', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.availableLanguages, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskLanguage', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.installationTypes, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('installationType', valueSelect.id)

			valueSelect = find(kioskCreationDefinition.data.kioskOwnerConfigs, (o) => o.selected === true)
			!isUndefined(valueSelect) && setValue('kioskOwnerConfig', valueSelect.id)
			//setSelectedProfile(kioskCreationDefinitionOptions.selectedProfile)

			if (!isEmpty(kioskCreationDefinition.data.storeInformation.pictures)) {
				let ar = []
				let blob
				_.forEach(kioskCreationDefinition.data.storeInformation.pictures, (pict, id) => {
					//blob = fileFromBase64(pict.pictureBase64, id)
					// Only push if element doesn't exist in our list
					ar.push(pict)
				})
				setListPictures(ar)
			}

			if (!isEqual(selectedProfile, {})) {
				if (!selectedProfile.standardProfile) {
					setValue('noteCommercial', kioskCreationDefinition.data.kioskInformation.noteCommercial)
				} else {
					// Getting racks information
					let notFoldedList = []
					!isNull(kioskCreationDefinition.data.customerDisplayStandInformation.displayStandTypes) &&
						kioskCreationDefinition.data.customerDisplayStandInformation.displayStandTypes[0].displayStandModel.forEach((elem) => {
							let elemToAdd = {}
							if (elem.displayStandTypeModelNumber > 0) {
								const obj = find(selectedProfile.displayStandConfig, (o) => o.translationKey === elem.displayStandModel)
								if (!isUndefined(obj)) {
									elemToAdd.id = obj.id
									elemToAdd.label = obj.label
									elemToAdd.count = elem.displayStandTypeModelNumber
									elemToAdd.smallLockerNumbers = obj.smallLockers
									elemToAdd.mediumLockerNumbers = obj.mediumLockers
									elemToAdd.largeLockerNumbers = obj.largeLockers
									elemToAdd.extraLargeLockerNumbers = obj.extraLargeLockers
									notFoldedList.push(elemToAdd)
								}
							}
						})

					let foldedList = []
					!isNull(kioskCreationDefinition.data.customerDisplayStandInformation.displayStandTypes) &&
						kioskCreationDefinition.data.customerDisplayStandInformation.displayStandTypes[1].displayStandModel.forEach((elem) => {
							let elemToAdd = {}
							if (elem.displayStandTypeModelNumber > 0) {
								const obj = find(selectedProfile.displayStandConfig, (o) => o.translationKey === elem.displayStandModel)
								if (!isUndefined(obj)) {
									elemToAdd.id = obj.id
									elemToAdd.label = obj.label
									elemToAdd.count = elem.displayStandTypeModelNumber
									elemToAdd.smallLockerNumbers = obj.foldedSmallLockers
									elemToAdd.mediumLockerNumbers = obj.foldedMediumLockers
									elemToAdd.largeLockerNumbers = obj.foldedLargeLockers
									elemToAdd.extraLargeLockerNumbers = obj.foldedExtraLargeLockers
									foldedList.push(elemToAdd)
								}
							}
						})

					let accessoriesList = []
					kioskCreationDefinition.data.displayStandInformation.forEach((elem) => {
						let elemToAdd = {}
						if (!isUndefined(elem.accessoryDisplayStand) && !isNull(elem.accessoryDisplayStand)) {
							const obj = find(selectedProfile.displayStandConfig, (o) => o.id === elem.idDisplayStandModel)
							if (!isUndefined(obj) && !isEmpty(elem.accessoryDisplayStand)) {
								const objAccNumb = find(
									obj.accessoryDisplayLockersNumber,
									(o) => o.id === elem.accessoryDisplayStand[0].idAccessoryLockersNumber
								)
								const hasAccessory = findIndex(accessoriesList, { id: elem.idAccessoryDisplayStandModel })
								if (hasAccessory === -1) {
									elemToAdd = {
										id: elem.idAccessoryDisplayStandModel,
										count: 1,
										label: translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName],
										countRacks: parseInt(objAccNumb.label),
									}
									accessoriesList.push(elemToAdd)
								} else {
									accessoriesList[hasAccessory].count++
								}
							}
						}
					})

					setRecapRack({
						foldedList: foldedList,
						notFoldedList: notFoldedList,
						smallLockerNumbers: kioskCreationDefinition.data.customerDisplayStandInformation.smallLockerNumber,
						mediumLockerNumbers: kioskCreationDefinition.data.customerDisplayStandInformation.mediumLockerNumber,
						largeLockerNumbers: kioskCreationDefinition.data.customerDisplayStandInformation.largeLockerNumber,
						extraLargeLockerNumbers: kioskCreationDefinition.data.customerDisplayStandInformation.extraLargeLockerNumber,
						accessoriesList: accessoriesList,
					})

					setAddedRackList(kioskCreationDefinition.data.displayStandInformation)
				}
			}

			// Disable fields if we are coming from "View" action, or by charging request with URL address
			let editable = true
			if (kioskCreation.forceReadOnly) {
				editable = false
			} else {
				editable = kioskCreationDefinition.data.progressInfo.editable
			}
			setIsEditable(editable)
			setDataLoaded(true)
		}
	}, [kioskCreationDefinition.data, stockRequestCheck, selectedProfile, dataLoaded])

	useEffect(() => {
		if (kioskCreationDefinition.data.progressInfo?.fromStock) {
			setIsEditableSecondCycle(kioskCreationDefinition.data.progressInfo?.fromStock)
		}
	}, [kioskCreationDefinition.data.progressInfo?.fromStock])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{dateInstallRenderModal()}
			<KioskCreationDefinitionCustomerWrapper>
				<PageWrapperLinksCustom rafterDisplayed={kioskCreation.statusId >= 6 ? true : false}>
					<Button goBack weight="bold" actionHandler={() => handleRedirect()} text={translations['common__text__previousPage']} />
				</PageWrapperLinksCustom>
				<form onSubmit={handleSubmit(onSubmit)}>
					<LineTableHeader>
						<PageTitle>{translations['page_admin_initKiosk_stepOne_title']}</PageTitle>
						<PageWrapperActions>
							<Button
								weight="bold"
								actionHandler={() => handleSubmit(onSubmit)}
								text={translations['page_admin_initKiosk_stepOne_button_send']}
								id={'ActionCreate'}
								bgColor={Theme.colors.validation}
								img={Validation}
								width={208}
								imgMgin={'16px'}
								noHash
								mgLeft={'5px'}
								disabled={(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)}
							/>
							<Tooltip tooltipId={'kioskCreationDefinitionCustomerCancel'} translationsKey={'tooltip_admin_initKiosk_stepOne_close'}>
								<PageWrapperActionPrevPage onClick={() => history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)} />
							</Tooltip>
							{/*<Tooltip
							tooltipId={ "kioskCreationDefinitionCustomerSave" }
							translationsKey={ "tooltip_admin_initKiosk_stepOne_save" }
						>
							<PageWrapperActionSave type="submit" id={"ActionSave"} disabled={!isEditable}/>
						</Tooltip>*/}
						</PageWrapperActions>
					</LineTableHeader>
					<PageWrapperGridsCustom grids={4}>
						<KioskCreationDefinitionCustomerColumn>
							<KioskCreationDefinitionCustomerPart>
								<KioskCreationDefinitionCustomerTitlePart>
									{translations['page_admin_initKiosk_stepOne_sheet_requestInformation']}
								</KioskCreationDefinitionCustomerTitlePart>
								<KioskCreationDefinitionCustomerContentPart>
									<KioskCreationDefinitionCustomerStockRequest>
										<div>
											<input
												type="checkbox"
												name="stockRequest"
												disabled={!isEditable || !isEqual(match.params, {})}
												checked={stockRequestCheck}
												ref={register({})}
												onClick={() => handleStockRequestCheck()}
											/>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_isStock']}</LabelText>
										</div>
										{stockRequestCheck && (
											<KioskCreationDefinitionCustomerStockRequestQuantity>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_quantity']}* :</LabelText>
												<InputWrapper>
													<InputLogin
														type="text"
														name="quantity"
														disabled={!isEditable || !isEqual(match.params, {})}
														placeholder={translations['page_admin_initKiosk_stepOne_sheet_quantity_placeholder']}
														ref={register({
															/*pattern: {
															value: /(?<=\s|^)\d+(?=\s|$)/,
															message:translations['common__text__positiveInteger']
														},*/
															//validate: value => ((stockRequestCheck && isNumber(parseInt(value)) && (parseInt(value) > 0 && parseInt(value) < 100) && value.length > 0) || !stockRequestCheck) || translations['common__text__requiredField']
															validate: (value) => {
																const v = parseInt(value)
																if (stockRequestCheck) {
																	if (value.length > 0) {
																		if (isNumber(v) && !isNaN(v)) {
																			if (v > 0 && v <= 10) {
																				return true
																			} else {
																				return StringFormatter.ResponseMessageParser(
																					translations['common__text__integerBetween'],
																					['0', '10']
																				)
																			}
																		} else {
																			return translations['common__text__positiveInteger']
																		}
																	} else {
																		return translations['common__text__requiredField']
																	}
																} else {
																	return true
																}
															},
														})}
													/>
													{errors.quantity && <ErrorInputMsg>{errors.quantity.message}</ErrorInputMsg>}
												</InputWrapper>
											</KioskCreationDefinitionCustomerStockRequestQuantity>
										)}
									</KioskCreationDefinitionCustomerStockRequest>
									<div>
										<LabelTextCustom>{translations['page_admin_initKiosk_stepOne_sheet_requestName']} :</LabelTextCustom>
										<InputWrapper>
											<InputLogin
												type="text"
												name="requestName"
												disabled={!isEditable}
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_requestName_placeholder']}
												ref={register({
													maxLength: {
														value: 100,
														message: `100 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.requestName && <ErrorInputMsg>{errors.requestName.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
								</KioskCreationDefinitionCustomerContentPart>
							</KioskCreationDefinitionCustomerPart>
							{!stockRequestCheck && (
								<KioskCreationDefinitionCustomerPart>
									<KioskCreationDefinitionCustomerTitlePart>
										{translations['page_admin_initKiosk_stepOne_sheet_companyInformation']} :
									</KioskCreationDefinitionCustomerTitlePart>
									<KioskCreationDefinitionCustomerContentPart>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_company_name']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>
											<InputWrapper>
												<InputLogin
													name="storeLabelCommercial"
													type="text"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													//!isUndefined(kioskCreationDefinition.data.progressInfo?.fromStock)
													placeholder={translations['page__itemsRef__itemSheet_form_volume_prefilled']}
													ref={register({
														maxLength: {
															value: 250,
															message: `250 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														required: {
															value: !stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.storeLabelCommercial && <ErrorInputMsg>{errors.storeLabelCommercial.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_storeType']} :</LabelText>
											<div>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														name="storeType"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																//value: !stockRequestCheck,
																value: false,
																message: translations['common__text__requiredField'],
															},
															//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
														})}
														className={watch('storeType') > 0 ? 'active' : ''}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_storeType_placeholder']}
														</OptionCustom>
														{map(kioskCreationDefinitionOptions.storeTypes, (elem, id) => {
															return (
																<OptionCustom key={id} value={elem.id} target={true}>
																	{translations[elem.translationKey]}
																</OptionCustom>
															)
														})}
													</SelectInputCustom>
												</SelectInputWrapper>
												{errors.storeType && <ErrorInputMsg>{errors.storeType.message}</ErrorInputMsg>}
											</div>
										</div>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_address']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>
											<InputWrapper>
												<InputLogin
													name="storeAddress"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page__itemsRef__itemSheet_form_volume_prefilled']}
													ref={register({
														maxLength: {
															value: 250,
															message: `250 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														required: {
															value: !stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.storeAddress && <ErrorInputMsg>{errors.storeAddress.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_postalCode']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>
											<InputWrapper>
												<InputLogin
													name="storePostalCode"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page__itemsRef__itemSheet_form_volume_prefilled']}
													ref={register({
														maxLength: {
															value: 15,
															message: `15 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														required: {
															value: !stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.storePostalCode && <ErrorInputMsg>{errors.storePostalCode.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_city']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>
											<InputWrapper>
												<InputLogin
													name="storeCity"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page__itemsRef__itemSheet_form_volume_prefilled']}
													ref={register({
														maxLength: {
															value: 150,
															message: `150 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														required: {
															value: !stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.storeCity && <ErrorInputMsg>{errors.storeCity.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_country']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>
											<SelectInputWrapper>
												<SelectInputCustom
													width="208"
													name="storeCountry"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													ref={register({
														required: {
															value: !stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
														validate: (value) =>
															(value > 0 && !stockRequestCheck) ||
															stockRequestCheck ||
															translations['common__text__requiredField'],
													})}
													className={watch('storeCountry') > 0 ? 'active' : ''}
												>
													<OptionCustom value="0" hidden>
														{translations['page_admin_initKiosk_stepOne_sheet_country_placeholder']}
													</OptionCustom>
													{map(kioskCreationDefinitionOptions.countries, (elem, id) => {
														return (
															<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																{elem.label}
															</OptionCustom>
														)
													})}
												</SelectInputCustom>
											</SelectInputWrapper>
											{errors.storeCountry && <ErrorInputMsg>{errors.storeCountry.message}</ErrorInputMsg>}
										</div>
										<div>
											<LabelText>
												{translations['page_admin_initKiosk_stepOne_sheet_siret']}
												{!stockRequestCheck ? '*' : ''} :
											</LabelText>
											<InputWrapper>
												<InputLogin
													name="storeSiret"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page__itemsRef__itemSheet_form_volume_prefilled']}
													ref={register({
														maxLength: {
															value: 50,
															message: `50 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														required: {
															value: !stockRequestCheck,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.storeSiret && <ErrorInputMsg>{errors.storeSiret.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_company_phone']} :</LabelText>
											<InputWrapper>
												<InputLogin
													name="storePhoneNumber"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_phone_placeholder']}
													ref={register({
														maxLength: {
															value: 250,
															message: `250 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
													})}
												/>
												{errors.storePhoneNumber && <ErrorInputMsg>{errors.storePhoneNumber.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_company_email']}* :</LabelText>
											<InputWrapper>
												<InputLogin
													name="storeEmail"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_email_placeholder']}
													ref={register({
														maxLength: {
															value: 150,
															message: `150 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														pattern: {
															value: RegExp(
																/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
															),
															message: translations['common__text__invalidEmail'],
														},
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.storeEmail && <ErrorInputMsg>{errors.storeEmail.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>

										{/*DEBUT AJOUT*/}
										<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_maintainer_declare']} :</SpanTitle>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_maintainer_input']}* :</LabelText>
											<InputWrapper>
												<InputLogin
													name="maintainer"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_maintainer_placeholder']}
													ref={register({
														maxLength: {
															value: 150,
															message: `150 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.maintainer && <ErrorInputMsg>{errors.maintainer.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>

										{/*FIN AJOUT*/}

										<div>
											<KioskCreationDefinitionCustomerSMSAvailable>
												<input
													type="checkbox"
													name="smsAvailable"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													ref={register({})}
												/>
												<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_smsSend']} :</LabelText>
											</KioskCreationDefinitionCustomerSMSAvailable>
										</div>
										<UploadHandler>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_photo']} :</LabelText>
											<ControllerFileWrapper>
												<input
													type="file"
													id="pictureBase64"
													name="pictureBase64"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													multiple="multiple"
													onChange={(e) => handleFileReading(e.target.files)}
													accept=".jpg,.png,.jpeg"
												/>
												<LabelFileCustom
													for="pictureBase64"
													width="208"
													isDisabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
												>
													{translations['page_admin_initKiosk_stepOne_sheet_photo_placeholder']}
												</LabelFileCustom>
												<span>{translations['page_admin_initKiosk_stepOne_sheet_photo_format']}</span>
											</ControllerFileWrapper>
										</UploadHandler>
										<UploadFileList>
											{errorsPictureBase64Msg.length > 0 && <ErrorInputMsg>{errorsPictureBase64Msg}</ErrorInputMsg>}
											{!isEmpty(listPictures) &&
												map(listPictures, (pict) => {
													return (
														<div>
															<span>{!isUndefined(pict.name) ? pict.name : pict.pictureName}</span>
															{(isEditable || isEditableSecondCycle) && (
																<Tooltip
																	tooltipId={'deleteChoice'}
																	translationsKey={'tooltip__admin__global__deletedChooice'}
																	position={'right'}
																>
																	<SearchResetCustom
																		onClick={() => {
																			handleDeletePicture(pict)
																		}}
																	/>
																</Tooltip>
															)}
														</div>
													)
												})}
										</UploadFileList>
									</KioskCreationDefinitionCustomerContentPart>
								</KioskCreationDefinitionCustomerPart>
							)}
						</KioskCreationDefinitionCustomerColumn>
						<KioskCreationDefinitionCustomerColumn>
							<KioskCreationDefinitionCustomerTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_contactInformation']}
							</KioskCreationDefinitionCustomerTitlePart>
							<KioskCreationDefinitionCustomerInfo>
								<div>
									<span>{translations['page_admin_initKiosk_stepOne_sheet_accountInformation']}</span>
									<Tooltip
										tooltipId={'kioskCreationDefinitionCustomerDisplayAccountInfo'}
										translationsKey={
											showAccountInfo ? 'tooltip_admin_initKiosk_stepOne_hide' : 'tooltip_admin_initKiosk_stepOne_display'
										}
									>
										<img
											src={showAccountInfo ? CloseEyeIcon : OpenEyeIcon}
											onClick={() => setShowAccountInfo(!showAccountInfo)}
										/>
									</Tooltip>
								</div>
								{(kioskCreationDefinitionOptions.userCreated || kioskCreationDefinition.data?.userCreated) && showAccountInfo && (
									<KioskCreationDefinitionCustomerAccountPart>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_lastname']} :</LabelText>
										<span>
											{isUpdate
												? kioskCreationDefinition.data?.userCreated?.lastName
												: kioskCreationDefinitionOptions.userCreated.lastName}
										</span>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_firstname']} :</LabelText>
										<span>
											{isUpdate
												? kioskCreationDefinition.data?.userCreated?.firstName
												: kioskCreationDefinitionOptions.userCreated.firstName}
										</span>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_email']} :</LabelText>
										<span>
											{isUpdate
												? kioskCreationDefinition.data?.userCreated?.email
												: kioskCreationDefinitionOptions.userCreated.email}
										</span>
									</KioskCreationDefinitionCustomerAccountPart>
								)}
							</KioskCreationDefinitionCustomerInfo>
							<KioskCreationDefinitionCustomerUserPhone>
								<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_phoneNumber']}* :</LabelText>
								<InputWrapper>
									<InputLogin
										name="currentUserPhoneNumber"
										type="text"
										disabled={!isEditable}
										defaultValue={
											kioskCreationDefinitionOptions.userCreated && kioskCreationDefinitionOptions.userCreated.phoneNumber
										}
										placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_phone_placeholder']}
										ref={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
									/>
									{errors.currentUserPhoneNumber && <ErrorInputMsg>{errors.currentUserPhoneNumber.message}</ErrorInputMsg>}
								</InputWrapper>
							</KioskCreationDefinitionCustomerUserPhone>
							{!stockRequestCheck && (
								<KioskCreationDefinitionCustomerContentPart>
									<SpanTitle>{translations['page_admin_initKiosk_stepOne_sheet_storeContactInformation']}</SpanTitle>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_lastname']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactLastName"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_lastname_placeholder']}
												ref={register({
													maxLength: {
														value: 250,
														message: `250 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.contactLastName && <ErrorInputMsg>{errors.contactLastName.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_firstname']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactFirstName"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_firstname_placeholder']}
												ref={register({
													maxLength: {
														value: 250,
														message: `250 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.contactFirstName && <ErrorInputMsg>{errors.contactFirstName.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_email']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactEmail"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_email_placeholder']}
												ref={register({
													maxLength: {
														value: 150,
														message: `150 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
													pattern: {
														value: RegExp(
															/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
														),
														message: translations['common__text__invalidEmail'],
													},
												})}
											/>
											{errors.contactEmail && <ErrorInputMsg>{errors.contactEmail.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
									<div>
										<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_store_phone']} :</LabelText>
										<InputWrapper>
											<InputLogin
												name="contactPhoneNumber"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												type="text"
												placeholder={translations['page_admin_initKiosk_stepOne_sheet_company_phone_placeholder']}
												ref={register({
													maxLength: {
														value: 250,
														message: `250 ${translations['common__text__charMax']}`,
													},
													minLength: {
														value: 1,
														message: `1 ${translations['common__text__charMin']}`,
													},
												})}
											/>
											{errors.contactPhoneNumber && <ErrorInputMsg>{errors.contactPhoneNumber.message}</ErrorInputMsg>}
										</InputWrapper>
									</div>
								</KioskCreationDefinitionCustomerContentPart>
							)}
						</KioskCreationDefinitionCustomerColumn>
						<KioskCreationDefinitionCustomerColumn>
							<KioskCreationDefinitionCustomerTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_kioskInformation']}
							</KioskCreationDefinitionCustomerTitlePart>
							<KioskCreationDefinitionCustomerContentPart>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_model']}* :</LabelText>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskModel"
												disabled={!isEditable}
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) =>
														(value > 0 && !stockRequestCheck) ||
														stockRequestCheck ||
														translations['common__text__requiredField'],
												})}
												className={watch('kioskModel') > 0 ? 'active' : ''}
												onChange={(e) => handleChangeKioskModel(e.target.value)}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kiosk_model_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.kioskModels, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskModel && <ErrorInputMsg>{errors.kioskModel.message}</ErrorInputMsg>}
									</div>
								</div>
							</KioskCreationDefinitionCustomerContentPart>
							{!stockRequestCheck && (
								<Fragment>
									<KioskCreationDefinitionCustomerContentPart>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_name']} :</LabelText>
											<InputWrapper>
												<InputLogin
													name="kioskLabelToOwner"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_name_placeholder']}
													ref={register({
														maxLength: {
															value: 250,
															message: `250 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
														validate: (value) =>
															KioskPdvHelper.isPdvValid(value, getValues('kioskDescription')) ||
															translations['common__message__kiosk_pdv_wrongFormat'],
													})}
												/>
												{errors.kioskLabelToOwner && <ErrorInputMsg>{errors.kioskLabelToOwner.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_label']}* :</LabelText>
											<InputWrapper>
												<InputLogin
													name="kioskDescription"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_label_placeholder']}
													ref={register({
														required: {
															value: true,
															message: translations['common__text__requiredField'],
														},
													})}
												/>
												{errors.kioskDescription && <ErrorInputMsg>{errors.kioskDescription.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationDate']}* :</LabelText>
											<CalendarInputInline
												name="kioskDateInstallation"
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												onClickHandler={dateInstallOpenDateModalHandler}
												valueInput={
													!isUndefined(currentDateInstall.date.startDate)
														? `${moment(currentDateInstall.date.startDate).format('DD/MM/YYYY')}`
														: ''
												}
											/>
											{errors.kioskDateInstallation && <ErrorInputMsg>{errors.kioskDateInstallation.message}</ErrorInputMsg>}
										</div>
										<div style={{ marginTop: !stockRequestCheck ? '10px' : '0px' }}>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_language']}* :</LabelText>
											{translations && kioskCreationDefinitionOptions.availableLanguages && (
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="kioskLanguage"
															disabled={
																(!isEditable && !isEditableSecondCycle) ||
																(kioskCreation.forceReadOnly && isEditableSecondCycle)
															}
															ref={register({
																required: {
																	value: true, //!stockRequestCheck,
																	message: translations['common__text__requiredField'],
																},
																validate: (value) =>
																	(value > 0 && !stockRequestCheck) ||
																	stockRequestCheck ||
																	translations['common__text__requiredField'],
															})}
															className={watch('kioskLanguage') > 0 ? 'active' : ''}
														>
															<OptionCustom value="0" hidden>
																{translations['page_admin_initKiosk_stepOne_sheet_kiosk_language_model']}
															</OptionCustom>
															{map(kioskCreationDefinitionOptions.availableLanguages, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																		{elem.labelEnglish}
																	</OptionCustom>
																)
															})}
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.kioskLanguage && <ErrorInputMsg>{errors.kioskLanguage.message}</ErrorInputMsg>}
												</div>
											)}
										</div>
									</KioskCreationDefinitionCustomerContentPart>
									<KioskCreationDefinitionCustomerTogglePart visible={true}>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_pda']} :</LabelText>
											<Controller
												control={control}
												name="pda"
												as={ToggleFilters}
												checked={currentPageSwitches?.pda}
												onChangeHandler={() => handleSwitchChange('pda')}
												disabled={
													(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)
												}
												reverseCheck
												size="large"
												rules={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
												})}
												labelPrev={translations['common__text__yes']}
												labelNext={translations['common__text__no']}
											/>
										</div>
									</KioskCreationDefinitionCustomerTogglePart>
									<KioskCreationDefinitionCustomerContentPart>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_message']} :</LabelText>
											<InputWrapper>
												<InputLogin
													name="welcomeMessage"
													disabled={
														(!isEditable && !isEditableSecondCycle) ||
														(kioskCreation.forceReadOnly && isEditableSecondCycle)
													}
													type="text"
													placeholder={translations['page_admin_initKiosk_stepOne_sheet_kiosk_message_placeholder']}
													ref={register({
														maxLength: {
															value: 200,
															message: `200 ${translations['common__text__charMax']}`,
														},
														minLength: {
															value: 1,
															message: `1 ${translations['common__text__charMin']}`,
														},
													})}
													width={'100%'}
												/>
												{errors.welcomeMessage && <ErrorInputMsg>{errors.welcomeMessage.message}</ErrorInputMsg>}
											</InputWrapper>
										</div>
										<div>
											<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationType']} :</LabelText>
											<div>
												<SelectInputWrapper>
													<SelectInputCustom
														width="208"
														name="installationType"
														disabled={
															(!isEditable && !isEditableSecondCycle) ||
															(kioskCreation.forceReadOnly && isEditableSecondCycle)
														}
														ref={register({
															required: {
																value: false, //!stockRequestCheck,
																message: translations['common__text__requiredField'],
															},
															//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
														})}
														className={watch('installationType') > 0 ? 'active' : ''}
													>
														<OptionCustom value="0" hidden>
															{translations['page_admin_initKiosk_stepOne_sheet_kiosk_installationType_placeholder']}
														</OptionCustom>
														{map(kioskCreationDefinitionOptions.installationTypes, (elem, id) => {
															return (
																<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
																	{translations[elem.translationKey]}
																</OptionCustom>
															)
														})}
													</SelectInputCustom>
												</SelectInputWrapper>
												{errors.installationType && <ErrorInputMsg>{errors.installationType.message}</ErrorInputMsg>}
											</div>
										</div>
									</KioskCreationDefinitionCustomerContentPart>
								</Fragment>
							)}
							<KioskCreationDefinitionCustomerTogglePart visible={true}>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solidDoor']} :</LabelText>
									<Controller
										control={control}
										name="solidDoor"
										as={ToggleFilters}
										checked={currentPageSwitches.solidDoor}
										onChangeHandler={() => handleSwitchChange('solidDoor')}
										disabled={!isEditable}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_lateralPanel']} :</LabelText>
									<Controller
										control={control}
										name="lateralPanel"
										as={ToggleFilters}
										checked={currentPageSwitches?.lateralPanel}
										onChangeHandler={() => handleSwitchChange('lateralPanel')}
										disabled={!isEditable}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_interiorCover']} :</LabelText>
									<Controller
										control={control}
										name="interiorCover"
										as={ToggleFilters}
										checked={currentPageSwitches?.interiorCover}
										onChangeHandler={() => handleSwitchChange('interiorCover')}
										disabled={!isEditable}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div style={{ display: `${!stockRequestCheck ? 'flex' : 'none'}` }}>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_restrictedLocation']} :</LabelText>
									<Controller
										control={control}
										name="restrictedLocation"
										as={ToggleFilters}
										checked={currentPageSwitches?.restrictedLocation}
										onChangeHandler={() => handleSwitchChange('restrictedLocation')}
										disabled={(!isEditable && !isEditableSecondCycle) || (kioskCreation.forceReadOnly && isEditableSecondCycle)}
										size="large"
										reverseCheck
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
							</KioskCreationDefinitionCustomerTogglePart>

							{/* PROFILE CONFIG PART */}

							<KioskCreationDefinitionCustomerTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_kioskOption_configuration']}
							</KioskCreationDefinitionCustomerTitlePart>
							<KioskCreationDefinitionCustomerContentPart>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kioskConfigInformation']}* :</LabelText>
									<div>
										<SelectInputWrapper>
											<SelectInputCustom
												width="208"
												name="kioskOwnerConfig"
												disabled={!isEditable}
												ref={register({
													required: {
														value: true,
														message: translations['common__text__requiredField'],
													},
													validate: (value) => value > 0 || translations['common__text__requiredField'],
												})}
												className={watch('kioskOwnerConfig') > 0 ? 'active' : ''}
												onChange={(e) => handleChangeProfile(e.target.value)}
											>
												<OptionCustom value="0" hidden>
													{translations['page_admin_initKiosk_stepOne_sheet_kioskPrfile_placeholder']}
												</OptionCustom>
												{map(kioskCreationDefinitionOptions.kioskOwnerConfigs, (elem, id) => {
													return (
														<OptionCustom key={id} value={elem.id} selected={elem.selected} target={true}>
															{elem.label}
														</OptionCustom>
													)
												})}
											</SelectInputCustom>
										</SelectInputWrapper>
										{errors.kioskOwnerConfig && <ErrorInputMsg>{errors.kioskOwnerConfig.message}</ErrorInputMsg>}
									</div>
								</div>
							</KioskCreationDefinitionCustomerContentPart>
							<KioskCreationDefinitionCustomerTogglePart visible={!isEqual(selectedProfile, {})}>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_platineSet']} :</LabelText>
									<Controller
										control={control}
										name="platineSet"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().platineSet}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('platineSet')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_marker']} :</LabelText>
									<Controller
										control={control}
										name="marker"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().marker}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('marker')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleDetaction']} :</LabelText>
									<Controller
										control={control}
										name="bottleDetectionAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().bottleDetectionAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('bottleDetectionAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_bottleMatterSensor']} :</LabelText>
									<Controller
										control={control}
										name="bottleMatterSensor"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().bottleMatterSensor}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('bottleMatterSensor')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_codePayment']} :</LabelText>
									<Controller
										control={control}
										name="codePaymentAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().codePaymentAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('codePaymentAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_tpa']} :</LabelText>
									<Controller
										control={control}
										name="tpaAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().tpaAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('tpaAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_scale']} :</LabelText>
									<Controller
										control={control}
										name="scaleAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().scaleAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('scaleAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_printer']} :</LabelText>
									<Controller
										control={control}
										name="printerAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().printerAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('printerAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_ticket']} :</LabelText>
									<Controller
										control={control}
										name="ticketByMailAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().ticketByMailAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('ticketByMailAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_solar']} :</LabelText>
									<Controller
										control={control}
										name="solarPanelAvailable"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().solarPanelAvailable}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('solarPanelAvailable')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
								<div>
									<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_kiosk_barCodeReader']} :</LabelText>
									<Controller
										control={control}
										name="barCodeReader"
										as={ToggleFilters}
										disabled={!isEditable}
										size="large"
										checked={getValues().barCodeReader}
										reverseCheck
										onChangeHandler={() => {
											handleProfileSelectedChange('barCodeReader')
										}}
										rules={register({
											required: {
												value: true,
												message: translations['common__text__requiredField'],
											},
										})}
										labelPrev={translations['common__text__yes']}
										labelNext={translations['common__text__no']}
									/>
								</div>
							</KioskCreationDefinitionCustomerTogglePart>
						</KioskCreationDefinitionCustomerColumn>
						<KioskCreationDefinitionCustomerColumn>
							<KioskCreationDefinitionCustomerTitlePart>
								{translations['page_admin_initKiosk_stepOne_sheet_rackInformation']}
							</KioskCreationDefinitionCustomerTitlePart>
							<KioskCreationDefinitionCustomerContentPart>
								{selectedProfile.standardProfile && (
									<KioskCreationDefinitionCustomerInfo themed="white">
										<div>
											<span>{translations['page_admin_initKiosk_stepOne_sheet_requestedRacks_resume']}</span>
										</div>
										<div>
											<KioskCreationDefinitionCustomerRacksInfoPart level={0}>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_rackNumber']} :</span>
														{addedRackList.length > 0 && <span>{addedRackList.length}</span>}
													</div>
												</li>
												<li>
													<KioskCreationDefinitionCustomerRacksInfoPart level={1}>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseFoldable']}</span>{' '}
																<span></span>
															</div>
															<KioskCreationDefinitionCustomerRacksInfoPart level={2}>
																{map(recapRack.foldedList, (elem) => (
																	<li>
																		<div>
																			<span>
																				{translations['page_admin_initKiosk_stepOne_sheet_whose']}{' '}
																				{elem.label}
																			</span>{' '}
																			<span>{elem.count}</span>
																		</div>
																	</li>
																))}
															</KioskCreationDefinitionCustomerRacksInfoPart>
														</li>
														<li>
															<div>
																<span>{translations['page_admin_initKiosk_stepOne_sheet_whoseUnfoldable']}</span>{' '}
																<span></span>
															</div>
															<KioskCreationDefinitionCustomerRacksInfoPart level={2}>
																{map(recapRack.notFoldedList, (elem) => (
																	<li>
																		<div>
																			<span>
																				{translations['page_admin_initKiosk_stepOne_sheet_whose']}{' '}
																				{elem.label}
																			</span>{' '}
																			<span>{elem.count}</span>
																		</div>
																	</li>
																))}
															</KioskCreationDefinitionCustomerRacksInfoPart>
														</li>
													</KioskCreationDefinitionCustomerRacksInfoPart>
												</li>
											</KioskCreationDefinitionCustomerRacksInfoPart>
											<KioskCreationDefinitionCustomerRacksInfoPart level={0}>
												<li>
													<div>
														<span>{translations['page_admin_initKiosk_stepOne_sheet_lockersNumber']} :</span>
														{(recapRack.smallLockerNumbers > 0 ||
															recapRack.mediumLockerNumbers > 0 ||
															recapRack.largeLockerNumbers > 0 ||
															recapRack.extraLargeLockerNumbers > 0) && (
															<span>
																{recapRack.smallLockerNumbers +
																	recapRack.mediumLockerNumbers +
																	recapRack.largeLockerNumbers +
																	recapRack.extraLargeLockerNumbers}
															</span>
														)}
													</div>
												</li>
												<KioskCreationDefinitionCustomerRacksInfoPart level={1}>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']}</span>
															{recapRack.smallLockerNumbers > 0 && <span>{recapRack.smallLockerNumbers}</span>}
														</div>
													</li>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_smallBottle_locker']}</span>
															{recapRack.mediumLockerNumbers > 0 && <span>{recapRack.mediumLockerNumbers}</span>}
														</div>
													</li>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_mediumBottle_locker']}</span>
															{recapRack.largeLockerNumbers > 0 && <span>{recapRack.largeLockerNumbers}</span>}
														</div>
													</li>
													<li>
														<div>
															<span>{translations['page_admin_initKiosk_stepOne_sheet_largeBottle_locker']}</span>
															{recapRack.extraLargeLockerNumbers > 0 && (
																<span>{recapRack.extraLargeLockerNumbers}</span>
															)}
														</div>
													</li>
												</KioskCreationDefinitionCustomerRacksInfoPart>
											</KioskCreationDefinitionCustomerRacksInfoPart>
											{/*<KioskCreationDefinitionCustomerRacksInfoPart level={0}>
											<li>
												<div><span>{translations['page_admin_initKiosk_stepOne_sheet_accessory_locker']}</span>
												{recapRack.accessoriesList.length > 0 &&
													renderAccessoriesCount()
												}
												</div>
											</li>
											<KioskCreationDefinitionCustomerRacksInfoPart level={1}>
												{
													map(recapRack.accessoriesList, elem => (
														<li>
															<div><span>{translations['page_admin_initKiosk_stepOne_sheet_whose']} {elem.label}</span> <span>{elem.countRacks*elem.count}</span></div>
														</li>
													))
												}
											</KioskCreationDefinitionCustomerRacksInfoPart>
										</KioskCreationDefinitionCustomerRacksInfoPart>*/}
										</div>
									</KioskCreationDefinitionCustomerInfo>
								)}
								{!isEmpty(addedRackList) && (
									<KioskCreationDefinitionCustomerRacksList>
										{map(addedRackList, (elem, key) => {
											const labelRack =
												elem?.labelRack?.length > 0 ? elem.labelRack : translations[elem.idDisplayStandModelName]
											const labelAccessory = !isUndefined(elem?.idAccessoryDisplayStandModel)
												? elem?.labelAccessory?.length > 0
													? elem.labelAccessory
													: translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName]
												: !isEmpty(elem.accessoryDisplayStand) &&
												  translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName].length > 0
												? translations[elem.accessoryDisplayStand[0].accessoryDisplayStandModelName]
												: ''
											return (
												<KioskCreationDefinitionCustomerRackItem disabled={!isEditable}>
													<span>{elem?.displayStandName}</span>
													<span>{`${labelRack}${labelAccessory.length > 0 ? '/' : ''}${labelAccessory}`}</span>
													{isEditable && (
														<Tooltip
															tooltipId={'kioskCreationDefinitionCustomerDeleteRack'}
															translationsKey={'tooltip_admin_initKiosk_stepOne_sheet_deleteRack'}
														>
															<img
																src={DeleteRackIcon}
																onClick={() => handleRackList('delete', key, labelRack, labelAccessory)}
															/>
														</Tooltip>
													)}
												</KioskCreationDefinitionCustomerRackItem>
											)
										})}
									</KioskCreationDefinitionCustomerRacksList>
								)}

								{!isEqual(selectedProfile, {}) && (
									<Fragment>
										<KioskCreationDefinitionCustomerRacksPart>
											{selectedProfile.standardProfile && (
												<Fragment>
													<div>
														<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_rackModel']} :</LabelText>
													</div>
													<div>
														<SelectInputWrapper>
															<SelectInputCustom
																width="208"
																name="idDisplayStandModel"
																disabled={!isEditable}
																ref={register({
																	required: {
																		value: false,
																		message: translations['common__text__requiredField'],
																	},
																	//validate:value => ((value > 0 && !stockRequestCheck) || stockRequestCheck) || translations['common__text__requiredField']
																})}
																className={watch('idDisplayStandModel') > 0 ? 'active' : ''}
																onChange={(e) => handleChangeRack(e.target.value)}
															>
																<OptionCustom value="0" hidden>
																	{translations['page_admin_initKiosk_stepOne_sheet_rackModel_placeholder']}
																</OptionCustom>
																{map(availableRackList, (elem, id) => {
																	const mainRackCount = _.countBy(addedRackList, (o) => o.isMain)
																	const multiMainRackCount = _.countBy(addedRackList, (o) => o.allowMultiMain)
																	return (
																		<OptionCustom
																			key={id}
																			value={elem.id}
																			target={true}
																			//hidden={((isEmpty(addedRackList) && !elem.isMain)) || (!secondaryAvailable && !elem.isMain)}
																			hidden={
																				(!isUndefined(mainRackCount.true) &&
																					isUndefined(multiMainRackCount.true) &&
																					elem.isMain) ||
																				(!isUndefined(multiMainRackCount.true) &&
																					elem.isMain &&
																					!elem.allowMultiMain) ||
																				(!elem.isMain &&
																					isUndefined(
																						mainRackCount.true
																					)) /* || !isUndefined(multiMainRackCount.true)*/
																			}
																		>
																			{translations[elem.translationKey]}
																		</OptionCustom>
																	)
																})}
															</SelectInputCustom>
														</SelectInputWrapper>
														{errors.idDisplayStandModel && (
															<ErrorInputMsg>{errors.idDisplayStandModel.message}</ErrorInputMsg>
														)}
													</div>
												</Fragment>
											)}
										</KioskCreationDefinitionCustomerRacksPart>
										<KioskCreationDefinitionCustomerRacksPart>
											{!isEqual(selectedRack, {}) && !isEqual(selectedProfile, {}) && (
												<Fragment>
													<div>
														<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_foldable']} :</LabelText>
													</div>
													<div>
														<Controller
															control={control}
															name="displayStandFolded"
															as={ToggleFilters}
															disabled={!isEditable}
															size="large"
															checked={selectedRack.displayStandFolded}
															reverseCheck
															onChangeHandler={() => {
																handleRackModelSelectedChange('displayStandFolded')
															}}
															rules={register({
																required: {
																	value: false,
																	message: translations['common__text__requiredField'],
																},
															})}
															labelPrev={translations['common__text__yes']}
															labelNext={translations['common__text__no']}
														/>
													</div>
													<div>
														<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_accessoryModule']} :</LabelText>
													</div>
													<div>
														<Controller
															control={control}
															name="accessoryRack"
															as={ToggleFilters}
															disabled={!isEditable || !selectedRack.allowAccessoryRack}
															size="large"
															checked={selectedRack.accessoryRack}
															reverseCheck
															onChangeHandler={() => {
																handleRackModelSelectedChange('accessoryRack')
															}}
															rules={register({
																required: {
																	value: false,
																	message: translations['common__text__requiredField'],
																},
															})}
															labelPrev={translations['common__text__yes']}
															labelNext={translations['common__text__no']}
														/>
													</div>
													{/*<div><LabelText>{translations['page_admin_initKiosk_stepOne_sheet_rack_solar']} :</LabelText></div>
													<div>
														<Controller
															control={control}
															name="solar"
															as={ToggleFilters}
															disabled={!isEditable}
															size="large"
															checked={selectedRack.solar}
															reverseCheck					
															onChangeHandler={() => {
																handleRackModelSelectedChange("solar")
															}}
															rules={ register( {
																		required: {
																			value: false,
																			message: translations['common__text__requiredField']
																		},
																} ) }
															labelPrev={translations['common__text__yes']}
															labelNext={translations['common__text__no']}
														/>
													</div>*/}
												</Fragment>
											)}
											{!isEqual(selectedProfile, {}) && !selectedProfile.standardProfile && (
												<Fragment>
													<div>
														<LabelText>{translations['page_admin_initKiosk_stepOne_sheet_salesmenMessage']} :</LabelText>
													</div>
													<div></div>
													<InputWrapper>
														<TextareaStyledCustom
															name="noteCommercial"
															disabled={!isEditable}
															type="text"
															placeholder={
																translations['page_admin_initKiosk_stepOne_sheet_salesmenMessage_placeholder']
															}
															ref={register({
																maxLength: {
																	value: 300,
																	message: `300 ${translations['common__text__charMax']}`,
																},
																minLength: {
																	value: 1,
																	message: `1 ${translations['common__text__charMin']}`,
																},
															})}
														/>
														{errors.noteCommercial && <ErrorInputMsg>{errors.noteCommercial.message}</ErrorInputMsg>}
													</InputWrapper>
												</Fragment>
											)}
										</KioskCreationDefinitionCustomerRacksPart>
									</Fragment>
								)}

								{selectedRack.accessoryRack && (
									<Fragment>
										<KioskCreationDefinitionCustomerRacksPartAccessory>
											<div>
												<div>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerNumber']}
														{!stockRequestCheck ? '*' : ''} :
													</LabelText>
												</div>
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="idAccessoryLockersNumber"
															disabled={!isEditable}
															ref={register({
																required: {
																	value: !stockRequestCheck,
																	message: translations['common__text__requiredField'],
																},
																validate: (value) =>
																	(value > 0 && !stockRequestCheck) ||
																	stockRequestCheck ||
																	translations['common__text__requiredField'],
															})}
															className={watch('idAccessoryLockersNumber') > 0 ? 'active' : ''}
														>
															<OptionCustom value="0" hidden>
																{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerNumber_placeholder']}
															</OptionCustom>
															{map(selectedRack.accessoryDisplayLockersNumber, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} target={true} selected={elem.selected}>
																		{translations[elem.translationKey]}
																	</OptionCustom>
																)
															})}
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.idAccessoryLockersNumber && (
														<ErrorInputMsg>{errors.idAccessoryLockersNumber.message}</ErrorInputMsg>
													)}
												</div>
												<div>
													<LabelText>
														{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerType']}
														{!stockRequestCheck ? '*' : ''} :
													</LabelText>
												</div>
												<div>
													<SelectInputWrapper>
														<SelectInputCustom
															width="208"
															name="idAccessoryDisplayStandModel"
															disabled={!isEditable}
															ref={register({
																required: {
																	value: !stockRequestCheck,
																	message: translations['common__text__requiredField'],
																},
																validate: (value) =>
																	(value > 0 && !stockRequestCheck) ||
																	stockRequestCheck ||
																	translations['common__text__requiredField'],
															})}
															className={watch('idAccessoryDisplayStandModel') > 0 ? 'active' : ''}
														>
															<OptionCustom value="0" hidden>
																{translations['page_admin_initKiosk_stepOne_sheet_accessoryLockerType_placeholder']}
															</OptionCustom>
															{map(selectedRack.accessoryDisplayStandModels, (elem, id) => {
																return (
																	<OptionCustom key={id} value={elem.id} target={true} selected={elem.selected}>
																		{translations[elem.translationKey]}
																	</OptionCustom>
																)
															})}
														</SelectInputCustom>
													</SelectInputWrapper>
													{errors.idAccessoryDisplayStandModel && (
														<ErrorInputMsg>{errors.idAccessoryDisplayStandModel.message}</ErrorInputMsg>
													)}
												</div>
											</div>
										</KioskCreationDefinitionCustomerRacksPartAccessory>
									</Fragment>
								)}
								{!isEqual(selectedProfile, {}) && selectedProfile.standardProfile && !isEqual(selectedRack, {}) && (
									<AddRackButtonWrapper>
										<Link onClick={() => handleRackList('add')} style={{ textDecoration: 'none' }}>
											<Button
												text={translations['page_admin_initKiosk_stepOne_button_addRack']}
												bgColor={Theme.colors.primary}
												height={32}
												iconHeight={15}
												img={AddRack}
											/>
										</Link>
									</AddRackButtonWrapper>
								)}
							</KioskCreationDefinitionCustomerContentPart>
						</KioskCreationDefinitionCustomerColumn>
					</PageWrapperGridsCustom>
				</form>
			</KioskCreationDefinitionCustomerWrapper>
		</Fragment>
	)
}

KioskCreationDefinitionCustomer.propTypes = {}

KioskCreationDefinitionCustomer.defaultPropTypes = {}

export default KioskCreationDefinitionCustomer
